import { useEffect, useState } from 'react';
import type { MutableRefObject } from 'react';

import { getActiveSectionId, getAllSections, getVisibleSectionIds, getVisibleSections } from './dom';

interface UseWatchingSectionStateParams {
  pathname: string;
  scrollToSection: (selector: string) => void;
  visibleSectionsRef: MutableRefObject<HTMLElement[]>;
}

export function useWatchingSectionState({
  pathname,
  scrollToSection,
  visibleSectionsRef,
}: UseWatchingSectionStateParams) {
  const [activeSectionId, setActiveSectionId] = useState<string | null>(null);
  const [visibleSectionIds, setVisibleSectionIds] = useState<string[]>([]);

  useEffect(() => {
    const update = () => {
      const visibleSections = getVisibleSections(getAllSections());
      visibleSectionsRef.current = visibleSections;
      setVisibleSectionIds(getVisibleSectionIds(visibleSections));
      setActiveSectionId(getActiveSectionId(visibleSections, window.scrollY + window.innerHeight / 2));
    };

    update();
    window.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [pathname, scrollToSection, visibleSectionsRef]);

  return {
    activeSectionId,
    visibleSectionIds,
  };
}
